import { styled } from '@mui/material/styles';
import clip from '@/components/DnDItem/clip.svg';

const grey = (theme) => theme.palette.grey[300];

export const Wrapper = styled('div', { label: 'DragSourceWrapper' })(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: '35%',
  zIndex: -1,
}));

export const Preview = styled('div', {
  label: 'DragSourcePreview',
  shouldForwardProp: (prop) => !['hasActiveStyle', 'hasLinkFolderstyle', 'hasActiveChildrenStyle'].includes(prop),
})(({ theme, hasActiveStyle, hasLinkFolderstyle, hasActiveChildrenStyle }) => ({
  height: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  background: theme.palette.common.white,
  border: `1px solid ${hasActiveChildrenStyle ? grey(theme) : 'none'}`,
  ...(hasActiveStyle && {
    '&:before': {
      content: '""',
      width: '100%',
      height: '100%',
      position: 'absolute',
      border: `1px solid ${grey(theme)}`,
      background: theme.palette.common.white,
      left: 5,
      top: -6,
      zIndex: -2,
    },
    '&:after': {
      content: '""',
      width: '100%',
      height: '100%',
      position: 'absolute',
      border: `1px solid ${grey(theme)}`,
      background: theme.palette.common.white,
      left: 11,
      top: -11,
      zIndex: -3,
    },
  }),
  ...(hasLinkFolderstyle && {
    '&:after': {
      content: '""',
      width: '34%',
      height: '30%',
      position: 'absolute',
      top: 0,
      left: '2%',
      background: `center / contain no-repeat url(${clip}), ${theme.palette.primary.light}`,
      borderRadius: [0, 0, 2, 2],
    },
  }),
}));

export const PreviewThumbnail = styled('img', { label: 'DragSourcePreviewThumbnail' })(() => ({
  maxHeight: '100%',
  width: '100%',
  height: 'auto',
  flex: 1,
}));
